import PropTypes from 'prop-types';
import { useEffect } from 'react';

const ExternalRedirect = props => {

  useEffect(() => {
    window.location.replace(props.to);
  }, [props.to]);

  return null;
}

ExternalRedirect.propTypes = {
  to: PropTypes.string
}

export default ExternalRedirect;